import { Icon } from '@iconify/react';

import Button, { ButtonProps } from './Button';

import './Button.scss';

type ButtonPropsWithoutChildren = Omit<ButtonProps, 'children'>;

export const ICON_SIZES = {
  sm: '1rem',
  md: '1.5rem',
  lg: '2rem',
};

export type IconSize = keyof typeof ICON_SIZES;

interface IconButtonNewProps extends ButtonPropsWithoutChildren {
  /**
   * The icon name as per the Iconify API. See https://icon-sets.iconify.design/
   * If icon set prefix is omitted, it is assumed to be 'material-symbols'.
   */
  icon: string;
  label?: string;
  orientation?: 'row' | 'column';
  iconSize?: IconSize;
  paddingSize?: 'sm' | 'md';
  iconColor?: 'auto' | 'red';
}

/**
 * Button which displays a label and an icon from the Iconify API.
 */
export default function IconButton({
  icon,
  label,
  orientation = 'row',
  iconSize = 'md',
  paddingSize = 'md',
  iconColor = 'auto',
  className = '',
  ...rest
}: IconButtonNewProps) {
  return (
    <Button
      className={`icon-button ${orientation} ${className} ${!label ? `even-padding-${paddingSize}` : ''}`}
      {...rest}
    >
      <div className="icon-wrapper">
        <Icon
          className={iconColor === 'auto' ? '' : `text-${iconColor}`}
          icon={icon.includes(':') ? icon : `material-symbols:${icon}`}
          height={ICON_SIZES[iconSize]}
          width={ICON_SIZES[iconSize]}
        />
      </div>
      {label && <span>{label}</span>}
    </Button>
  );
}
